if (import.meta.env.DEV) {
  // GOOGLE
  // AIzaSyDzl9TI-p5JqwKuuGKEwsGdCR7JLKS9f48 - Restricted
  // AIzaSyBazS0Sqv0Ys9F5oJaQzpIi8sz3EJNttWc - Not Restricted
  // --------------------------------------------------------------
  // MAPBOX
  // pk.eyJ1Ijoib3RvZGV2IiwiYSI6ImNsdWg4dXg0cTB1d3Uya29jNHFsZmJ6M2IifQ.nEJzl5DzYUNDGsvY5rFcrw
}

export const MapsProviderEnum = {
  Google: 'google',
  MapBox: 'mapbox'
}

export default {
  data() {
    return {}
  },
  methods : {},
  computed: {
    defaultMapsProvider() {
      return this.appConfig?.LOCATION_DATA?.Maps?.Pos?.DefaultMapsProvider || null
    },
    interactiveMapsProvider() {
      return this.appConfig?.LOCATION_DATA?.Maps?.Pos?.InteractiveMapsProvider || null
    },
    staticMapsProvider() {
      return this.appConfig?.LOCATION_DATA?.Maps?.Pos?.StaticMapsProvider || null
    },
    geocodeProvider() {
      return this.appConfig?.LOCATION_DATA?.Maps?.Pos?.GeocodeProvider || this.interactiveMapsProvider || this.staticMapsProvider || null
    }
  }
}
